document.addEventListener('DOMContentLoaded', function () {
  document.body.addEventListener('click', function (e) {
    const link = e.target.closest('a');
    if (link && link.getAttribute('href') === '#chatra-start-chat') {
      e.preventDefault();
      if (typeof Chatra === 'function') {
        console.log('Clicked Chatra open link');
        Chatra('openChat', true);
      } else {
        console.warn('Chatra is not defined.');
      }
    }
  });
});
